import _ from 'lodash';
import { getFileName, genId, isOnline, base64ToBlob, readAsArrayBuffer } from '../../util';
import StoreService from '../../services/api/store';
import Api from '../../services/api';
import CONSTANT from '../../constant';
import Config from '../../config';
import ProjectAction from '../project/action';
import ProjectApi from '../../services/api/project';
import Mscratch from '../../services/mscratch';
import Uploader from '../../services/api/uploader';
import ProjectLocal from '../../services/project/project.local';
import projectModel from '../../model/project.model';

import {
    SYNC_PROJECTS, DOWNLOAD_PROJECT, DELETE_PROJECT, COPY_PROJECT,
    SHARE_PROJECT, UPLOAD_COVERIMG, CLEAR_PROJECTS
} from './actionTypes';
import { message } from 'antd';
import mElectronApi from '../../util/electron';

export default class ActionYun {
    constructor(store) {
        this.store = store;
    }

    // todo！！待优化cb
    async syncList(successCb, failCb) {
        if (Config.showCopyrightLogo) return;
        const store = this.store;
        const { account, project } = store.getState();
        ProjectAction.syncMsg(store, CONSTANT.PROJECT_SYNC_STATUS['SYNCING']);
        let syncLabel = '';
        let payload = {};
        // 获取我的云端作品列表
        let myCloudList = null;
        if (account.isLogin) {
            try {
                await Api.ProjectService.get_cloud_projects({
                    '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) }
                }).then(res => {
                    myCloudList = res.cloudProjectList.map((c) => {
                        return { ...c, isDeleted: c.isDeleted === 1, isShare: c.isShare === 1 };
                    });
                });
            } catch (error) {
                console.log('同步失败，无网络: ', error);
                myCloudList = null;
                ProjectAction.syncMsg(store, CONSTANT.PROJECT_SYNC_STATUS['NONETWORK']);
                syncLabel = CONSTANT.PROJECT_SYNC_STATUS['NONETWORK'];
            }
        }

        const userId = String(account.data.uid || 'null');
        // 获取本地作品列表
        let localList = await ProjectLocal.get(), myLocalList = [];
        if (project.currentUserId !== String(account.data.uid)) {
            try {
                // 获取我的本地作品列表
                myLocalList = Api.ProjectService.getMyLocalList(userId, localList);
                payload.currentUserId = account.data.uid ? String(account.data.uid) : 'null';
            } catch (error) {
                console.log('syncMyList error: ', error);
                localList = {};
                myLocalList = [];
            }
        } else {
            myLocalList = project.projects;
        }

        try {
            // 同步我的作品列表
            const syncList = Api.ProjectService.syncMyList(myCloudList, myLocalList);
            console.log('syncList: ', syncList);
            // 更新本地作品列表
            localList[userId] = syncList;
            // 写入JSON文件
            ProjectLocal.set(localList);

            payload.projects = syncList;
            store.dispatch({ type: SYNC_PROJECTS, payload });
            ProjectAction.syncMsg(store, syncLabel || CONSTANT.PROJECT_SYNC_STATUS['SUCCESS']);
            _.isFunction(successCb) && successCb();

            // 开始上传文件和记录
            this.syncProjects();

        } catch (error) {
            ProjectAction.syncMsg(store, CONSTANT.PROJECT_SYNC_STATUS['FAIL']);
            _.isFunction(failCb) && failCb(error);
        }
    }

    syncProjects() {
        const store = this.store;
        const { projects } = store.getState().project;
        const uploadingIds = () => {
            let ids = [];
            try {
                ids = Uploader.GetList().map((l) => l.data.info.id);
            } catch (err) {
                console.log('Uploader.GetList err: ', err);
            }
            return ids;
        };
        projects.forEach(async (p) => {
            const uploadingProjectIds = uploadingIds();
            if (_.indexOf([CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL'], CONSTANT.PROJECT_STATUS['WILL_UPLOAD_FILE']], p.syncStatus) !== -1 &&
                _.indexOf(uploadingProjectIds, p.id) === -1
            ) {
                this.syncUploadProjects(p);
            } else if (p.syncStatus === CONSTANT.PROJECT_STATUS['WILL_UPLOAD_RECORD']) {
                this.syncRenameProjects(p);
            } else if (p.syncStatus === CONSTANT.PROJECT_STATUS['WILL_DELETE']) {
                this.syncDeleteProjects(p);
            }
        });
    }

    async syncUploadProjects(project) {
        const store = this.store;
        const { id, projectId, projectName, userId, localName, coverImage, createdAt, syncStatus } = project;
        let _coverImage = '';
        if (coverImage) {
            const fileObj = await mElectronApi.read(coverImage);
            _coverImage = await Api.ProjectService.uploadCoverImage(fileObj.data, localName);
        }
        const info = { id, projectId, projectName, localName, createdAt, syncStatus, coverImage: _coverImage };
        Uploader.SetStore(store).Push({
            type: Uploader.Constant().PROJECT,
            data: {
                info: info,
                filePath: Config.userProjectFilePath + '/' + localName + '.mblock',
                utoken: StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
                uid: userId
            }
        });
    }

    async syncRenameProjects(project) {
        const store = this.store;
        const { projects } = this.store.getState().project;
        let _projects = projects;
        const localList = await ProjectLocal.get();
        let _localList = localList;
        const { id, projectId, projectName, userId, createdAt } = project;
        if (projectId) {
            try {
                Api.ProjectService.rename_project({
                    createdAt, projectName, projectId,
                    '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) }
                }).then(async () => {
                    _projects = _projects.map((p) => {
                        return p.id === id ?
                            {
                                ...p,
                                syncStatus: p.syncStatus === CONSTANT.PROJECT_STATUS['WILL_UPLOAD_RECORD'] ?
                                    CONSTANT.PROJECT_STATUS['NORMAL'] : p.syncStatus
                            } : p;
                    });
                    _localList[userId] = _projects;
                    // 写JSON，正常状态
                    ProjectLocal.set(_localList);
                    store.dispatch(ProjectAction.rename({ projects: _projects }));
                });
            } catch (err) {
                return;
            }
        }
    }

    async syncDeleteProjects(project) {
        const store = this.store;
        const { projects } = this.store.getState().project;
        let _projects = projects;
        const localList = await ProjectLocal.get();
        let _localList = localList;
        const { id, projectId, userId } = project;
        if (projectId) {
            try {
                Api.ProjectService.delete_project({ projectId, '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) } }).then(async () => {
                    _projects = _projects.map((p) => {
                        return p.id === id ? { ...p, syncStatus: CONSTANT.PROJECT_STATUS['NORMAL'] } : p;
                    });
                    _localList[userId] = _projects;
                    // 写JSON，正常状态
                    ProjectLocal.set(_localList);
                    store.dispatch({
                        type: DELETE_PROJECT,
                        payload: { projects: _projects }
                    });
                });
            } catch (err) {
                return;
            }
        }
    }

    async ReDownloadProject(callback) {
        const store = this.store;
        const { id, projectId,localName, commitId } = store.getState().project;
        try {
            this.downloadProject(commitId, localName, id, projectId, (err, filePath) => {
                if (err) {
                    return console.log('下载失败，open_project跳过。');
                }
                const { id, name, localName, projectId, commitId } = store.getState().project;
                ProjectAction.Strategy(store).OpenProject(filePath, {
                    id, name: name, localName, projectId, commitId, projectType: CONSTANT.PROJECT_TYPE.LIST,
                    filePath, projectStatus: CONSTANT.PROJECT_STATUS['NORMAL']
                });
            });
        } catch (err) {
            _.isFunction(callback) && callback(err);
        }
    }

    async downloadProjectCoverImg(url, localName, id) {
        const filePath = Config.userCoverImageFilePath + '/' + localName + '-' + new Date().getTime() + '.jpg';
        await Api.OssService.downloadCoverImage({ url, filePath, localName }, async (err) => {
            if (err) {
                console.log('download project coverImage err', err);
                return;
            }
            const obj = { coverImage: filePath };
            projectModel.updateProject(DOWNLOAD_PROJECT, id, obj);
        });
    }

    async downloadProject(commitId, localName, id, projectId, callback) {
        const store = this.store;
        const { account, intlr } = store.getState();
        if (!isOnline()) {
            const { messages } = intlr;
            store.dispatch({
                type: DOWNLOAD_PROJECT,
                payload: { downloadStatus: { err: messages['NETWORK.ERR.MSG'], percent: 0 } }
            });
            return;
        }
        console.log('进入download项目.');
        const res = await Api.OssService.downloadToken({
            utoken: StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY), pid: 1, cloudProjectId: projectId, classToken: ''
        });
        if (res) {
            res.commitId = commitId;
            res.localName = localName;

            Api.OssService.downloadFile(res, async (err, data) => {
                // 当前项目的下载逻辑
                const handleCurrent = (isFinish) => {
                    if (store.getState().project.id === data.id) {
                        store.dispatch({ type: DOWNLOAD_PROJECT, payload: { downloadStatus: { err, percent: data.percent } } });
                        if (!isFinish) return;
                        const filPath = Config.userProjectFilePath + '/' + localName + '.mblock';
                        store.dispatch({
                            type: DOWNLOAD_PROJECT,
                            payload: {
                                projectStatus: CONSTANT.PROJECT_STATUS['NORMAL']
                            }
                        });
                        _.isFunction(callback) && callback(null, filPath);
                    }
                };
                // 处理后台项目下载逻辑
                const handleBack = async (isFinish) => {
                    if (!isFinish) return;
                    const { projects } = store.getState().project;
                    const _projects = projects.map((p) => p.id === id ? {
                        ...p,
                        syncStatus: CONSTANT.PROJECT_STATUS['NORMAL']
                    } : p);
                    const userId = String(account.data.uid);
                    let _localList = await ProjectLocal.get();
                    _localList[userId] = _projects;
                    ProjectLocal.set(_localList);
                    store.dispatch({
                        type: DOWNLOAD_PROJECT,
                        payload: {
                            projects: _projects
                        }
                    });
                };

                const isFinish = data.percent === 100;
                handleCurrent(isFinish);
                await handleBack(isFinish);
            });
        } else {
            throw new Error('get oss download token failed.');
        }
    }

    async OpenProject(_id, callback) {
        console.log('进入yun->OpenProject.');
        const store = this.store;
        const { projects } = store.getState().project;
        const project = projects.filter((p) => p.id === _id)[0];
        const { id, projectName, localName, projectId, commitId, syncStatus, createdAt, coverImage } = project;

        let filePath = Config.userProjectFilePath + '/' + localName + '.mblock';

        const open = (err, filePath) => {
            if (err) {
                return console.log('下载失败，open_project跳过。');
            }
            const { id, name, localName, projectId, commitId } = store.getState().project;
            ProjectAction.Strategy(store).OpenProject(filePath, {
                id, name: name, localName, projectId, commitId, projectType: CONSTANT.PROJECT_TYPE.LIST,
                filePath
            });
        };

        store.dispatch(ProjectAction.saved({
            id,
            name: projectName,
            localName,
            projectId,
            commitId,
            projectType: CONSTANT.PROJECT_TYPE['LIST'],
            projectStatus: syncStatus,
            createdAt,
            saveStatus: '',
            coverImage
        }));

        if (syncStatus === CONSTANT.PROJECT_STATUS.WILL_DOWNLOAD && commitId) {
            try {

                await this.downloadProject(commitId, localName, id, projectId, open);
                await this.downloadProjectCoverImg(coverImage, localName, id);
                _.isFunction(callback) && callback(null);
            } catch (e) {
                _.isFunction(callback) && callback(e);
                console.error(e);
            }
        } else {
            open(null, filePath);
        }
    }

    async SaveProject(isSaveas, projectInfo = {}) {
        Mscratch.stop();
        const store = this.store;
        const { project, account, intlr } = store.getState();
        let { id, projectId, name, localName, filePath, saveStatus, projects } = project;
        if (saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
            return;
        }
        const userId = account.data.uid || 'null';
        let _projects = [];
        const _id = genId();

        if (!_.has(projectInfo, 'name')) {
            projectInfo.name = '';
        }
        if (projectInfo.name === '') {
            projectInfo.name = name ? name : ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects);
        }
        store.dispatch(ProjectAction.saved({ name: projectInfo.name, saveStatus: CONSTANT.PROJECT_SAVE_STATUS.DOING }));
        projectInfo.filePath = filePath;
        if (isSaveas || !filePath || !localName) {
            projectInfo.filePath = Config.userProjectFilePath + '/' + _id + '.mblock';
        }

        const ids = projects.map((p) => p.id);
        const createdAt = Date.parse(new Date()) / 1000;
        if (!isSaveas && _.indexOf(ids, id) > -1) {
            _projects = projects.map((p) => p.id === id ? {
                ...p,
                createdAt,
                projectName: projectInfo.name,
                syncStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_FILE']
            } : p);
            projectInfo = {
                ...projectInfo, id, name: name || '', projectId, createdAt, localName,
                projectStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_FILE']
            };
        } else {
            id = _id;
            const newProject = {
                id: _id,
                userId: String(userId),
                projectId: '',
                commitId: '',
                createdAt,
                projectName: projectInfo.name,
                localName: _id,
                syncStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL'],
                isDeleted: false,
                isShare: false,
                coverImage: ''
            };
            _projects = projects;
            _projects.push(newProject);
            projectInfo = {
                ...projectInfo, id, projectId: '', createdAt, localName: _id,
                projectType: CONSTANT.PROJECT_TYPE.LIST, projectStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL']
            };
        }
        let _localList = await ProjectLocal.get();
        _localList[userId] = _projects;

        try {
            // 写回JSON
            ProjectLocal.set(_localList);
            store.dispatch(ProjectAction.saved({
                preProjectData: Mscratch.getProjectJsonString(),
                projectType: CONSTANT.PROJECT_TYPE.LIST,
                projects: _projects
            }));
            const coverImage = await this.SaveProjectImg(id);
            await ProjectAction.Strategy(store).SaveProject(false, projectInfo);
            if (account.isLogin) {
                const { id, projectId, name, localName, createdAt, projectStatus } = projectInfo;
                const info = { id, projectId, projectName: name, localName, createdAt, syncStatus: projectStatus, coverImage };
                // 插入上传队列
                Uploader.SetStore(store).Push({
                    type: Uploader.Constant().PROJECT,
                    data: {
                        info: info,
                        filePath: projectInfo.filePath,
                        utoken: StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
                        uid: userId
                    }
                });
                ProjectAction.SaveMsg(store, CONSTANT.PROJECT_SAVE_STATUS.SUCCESS);
            } else {
                ProjectAction.SaveMsg(store, CONSTANT.PROJECT_SAVE_STATUS.SUCCESS);
            }
        } catch (err) {
            ProjectAction.SaveMsg(store, CONSTANT.PROJECT_SAVE_STATUS.FAILURE);
            const { messages } = intlr;
            const failMsg = messages['EXPORT.FAIL.MSG'];
            if (err.matchStr) {
                message.error(err.matchStr + messages['RENAME.ERR.KEY.MSG']);
            } else if (err.msg) {
                message.error(messages[err.msg]);
            } else {
                message.error(failMsg);
            }
        }
    }

    async SaveProjectImg(id) {
        const base64 = await Mscratch.getProjectCoverPic();
        const blob = await base64ToBlob(base64);
        const buff = await readAsArrayBuffer(blob);
        const localName = id;

        const store = this.store;
        const { projects } = store.getState().project;
        try {
            const project = projects.filter((p) => p.id === id)[0];
            const filePath = Config.userCoverImageFilePath + '/' + localName + '-' + new Date().getTime() + '.jpg';
            await mElectronApi.save(buff, filePath);

            const obj = { coverImage: filePath };
            projectModel.updateProject(UPLOAD_COVERIMG, id, obj);
            mElectronApi.removeFromLocal({ path: project.coverImage });

            const coverImage = await Api.ProjectService.uploadCoverImage(blob, localName);
            return coverImage;
        } catch (err) {
            console.log('err: 保存项目封面出错 ', err);
            return '';
        }
    }

    async copyProjectImg(id, srcId) {
        const store = this.store;
        const { projects } = store.getState().project;
        try {
            const project = projects.filter((p) => p.id === srcId)[0];
            const srcPath = project.coverImage;
            const descPath = Config.userCoverImageFilePath + '/' + id + '-' + new Date().getTime() + '.jpg';
            await ProjectAction.Strategy(store).copyFile(srcPath, descPath);
            const obj = { coverImage: descPath };
            projectModel.updateProject(UPLOAD_COVERIMG, id, obj);

            const fileObj = await mElectronApi.read(descPath);
            return await Api.ProjectService.uploadCoverImage(fileObj.data, id);
        } catch (err) {
            console.log('err: 复制项目封面出错 ', err);
        }
    }

    async RenameProject(data, callback) {
        const store = this.store;
        const { project, account } = store.getState();
        const { projects } = project;
        const userId = account.data.uid || 'null';
        const { id, projectId, projectName, createdAt, syncStatus } = data;
        let _projects = [];
        let _localList = await ProjectLocal.get();
        try {
            _projects = projects.map((p) => {
                return p.id === id ?
                    {
                        ...p, projectName, createdAt,
                        syncStatus: _.indexOf([CONSTANT.PROJECT_STATUS['WILL_DOWNLOAD'], CONSTANT.PROJECT_STATUS['WILL_UPLOAD_RECORD'], CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL']], syncStatus) > -1
                            ? syncStatus
                            : syncStatus === CONSTANT.PROJECT_STATUS['WILL_UPLOAD_FILE']
                                ? CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL']
                                : CONSTANT.PROJECT_STATUS['WILL_UPLOAD_RECORD']
                    } : p;
            });
            _localList[userId] = _projects;
            // 写JSON，待记录状态
            ProjectLocal.set(_localList);
            store.dispatch(ProjectAction.rename({
                projects: _projects,
                name: project.id === id ? projectName : project.name
            }));
        } catch (err) {
            _.isFunction(callback) && callback(err);
            return;
        }
        // 请求修改作品名api
        if (projectId) {
            try {
                Api.ProjectService.rename_project({
                    createdAt, projectName, projectId,
                    '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) }
                }).then(async () => {
                    _projects = _projects.map((p) => {
                        return p.id === id ?
                            {
                                ...p,
                                syncStatus: p.syncStatus === CONSTANT.PROJECT_STATUS['WILL_UPLOAD_RECORD'] ?
                                    CONSTANT.PROJECT_STATUS['NORMAL'] : p.syncStatus
                            } : p;
                    });
                    _localList[userId] = _projects;
                    // 写JSON，正常状态
                    ProjectLocal.set(_localList);
                    store.dispatch(ProjectAction.rename({ projects: _projects }));
                });
            } catch (err) {
                _.isFunction(callback) && callback(err);
                return;
            }
        }
        _.isFunction(callback) && callback();
    }

    async deleteProject(id, callback) {
        const store = this.store;
        const { project, account } = store.getState();
        const { projects } = project;
        const userId = account.data.uid || 'null';
        const createdAt = Date.parse(new Date()) / 1000;
        let _projects = projects.map((p) => p.id === id
            ? {
                ...p, isDeleted: true, createdAt,
                syncStatus: p.projectId ? CONSTANT.PROJECT_STATUS['WILL_DELETE'] : CONSTANT.PROJECT_STATUS['NORMAL']
            } : p);
        const _localList = await ProjectLocal.get();
        _localList[userId] = _projects;
        try {
            // 写JSON，待删除状态
            ProjectLocal.set(_localList);
            store.dispatch({
                type: DELETE_PROJECT,
                payload: { projects: _projects }
            });
        } catch (err) {
            _.isFunction(callback) && callback(err);
            return;
        }

        const _project = _projects.filter((p) => p.id === id)[0];
        const { projectId } = _project;
        if (projectId) {
            try {
                Api.ProjectService.delete_project({ projectId, '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) } }).then(async () => {
                    _projects = _projects.map((p) => {
                        return p.id === id ? { ...p, syncStatus: CONSTANT.PROJECT_STATUS['NORMAL'] } : p;
                    });
                    _localList[userId] = _projects;
                    // 写JSON，正常状态
                    ProjectLocal.set(_localList);
                    store.dispatch({
                        type: DELETE_PROJECT,
                        payload: { projects: _projects }
                    });
                });
            } catch (err) {
                _.isFunction(callback) && callback(err);
                return;
            }
        }
        _.isFunction(callback) && callback();
    }

    async copyProject(data, cb) {
        const store = this.store;
        const { account, project } = store.getState();
        const { userId, projectName, localName } = data;
        const _projectName = ProjectApi.getNewProjectName(projectName, project.projects);

        const args = { projectName: _projectName };
        const newProject = await projectModel.addProject(COPY_PROJECT, args);
        try {
            const srcPath = Config.userProjectFilePath + '/' + localName + '.mblock';
            const descPath = Config.userProjectFilePath + '/' + newProject.id + '.mblock';
            await ProjectAction.Strategy(store).copyFile(srcPath, descPath);
            const coverImage = await this.copyProjectImg(newProject.id, localName);

            if (account.isLogin) {
                const info = { ...newProject, coverImage };
                Uploader.SetStore(store).Push({
                    type: Uploader.Constant().PROJECT,
                    data: {
                        info: info,
                        filePath: descPath,
                        utoken: StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
                        uid: userId
                    }
                });
            }
            _.isFunction(cb) && cb();
        } catch (err) {
            _.isFunction(cb) && cb(err);
        }
    }

    async dragAddProject(data, cb) {
        const store = this.store;
        const { path } = data;
        const projectName = getFileName(path);
        const { project, account } = store.getState();
        const { projects } = project;
        const _id = genId();
        const createdAt = Date.parse(new Date()) / 1000;
        const userId = String(account.data.uid || 'null');
        const newProject = {
            id: _id,
            userId,
            projectId: '',
            commitId: '',
            createdAt,
            projectName,
            localName: _id,
            syncStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL'],
            isDeleted: false,
            isShare: false,
            coverImage: ''
        };
        let _projects = projects;
        _projects.push(newProject);
        let _localList = await ProjectLocal.get();
        _localList[userId] = _projects;
        try {
            const descPath = Config.userProjectFilePath + '/' + newProject.localName + '.mblock';
            await ProjectAction.Strategy(store).copyFile(path, descPath);
            // 写回JSON
            ProjectLocal.set(_localList);
            store.dispatch({
                type: COPY_PROJECT,
                payload: { projects: _projects }
            });
            if (account.isLogin) {
                // const coverImage = await this.SaveProjectImg(newProject.id);
                const { id, projectId, projectName, userId, localName, createdAt, syncStatus } = newProject;
                const info = { id, projectId, projectName, localName, createdAt, syncStatus, coverImage: '' };
                Uploader.SetStore(store).Push({
                    type: Uploader.Constant().PROJECT,
                    data: {
                        info: info,
                        filePath: Config.userProjectFilePath + '/' + localName + '.mblock',
                        utoken: StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
                        uid: userId
                    }
                });
            }
            _.isFunction(cb) && cb();
        } catch (err) {
            _.isFunction(cb) && cb(err);
        }
    }

    async shareProject(data, cb) {
        const { id, projectName, introduction, description } = data;
        const store = this.store;
        const { project, account } = store.getState();
        const { projects } = project;
        const _project = projects.filter((p) => p.id === id)[0];
        const { projectId } = _project;
        try {
            await Api.ProjectService.share_project({
                cloudProjectId: projectId, projectName, projectDescription: introduction, projectIntroduction: description,
                '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) }
            }).then(async () => {
                const userId = account.data.uid;
                let _projects = projects.map((p) => p.id === id ? { ...p, isShare: true } : p);
                const _localList = await ProjectLocal.get();
                _localList[userId] = _projects;
                // 写JSON
                ProjectLocal.set(_localList);
                store.dispatch({
                    type: SHARE_PROJECT,
                    payload: { projects: _projects }
                });
                _.isFunction(cb) && cb();
            });
        } catch (err) {
            _.isFunction(cb) && cb(err);
        }
    }

    async cancelShareProject(id, cb) {
        const store = this.store;
        const { project, account } = store.getState();
        const { projects } = project;
        const _project = projects.filter((p) => p.id === id)[0];
        const { projectId } = _project;
        try {
            await Api.ProjectService.cancel_share_project({ cloudProjectId: projectId, '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) } }).then(async () => {
                const userId = account.data.uid;
                let _projects = projects.map((p) => p.id === id ? { ...p, isShare: false } : p);
                const _localList = await ProjectLocal.get();
                _localList[userId] = _projects;
                // 写JSON
                ProjectLocal.set(_localList);
                store.dispatch({
                    type: SHARE_PROJECT,
                    payload: { projects: _projects }
                });
                _.isFunction(cb) && cb();
            });
        } catch (err) {
            _.isFunction(cb) && cb(err);
        }
    }

    clearProjects() {
        const store = this.store;
        store.dispatch({ type: CLEAR_PROJECTS, payload: { projects: [], currentUserId: 'null' } });
    }
}